<script>
    import FooterBottom from "@/components/footer/FooterBottom";
    import TheFooterMain from "@zavtra/components/TheFooterMain";

    export default {
        name: "TheFooter",
        components: {
            TheFooterMain,
            FooterBottom,
        },
    };
</script>

<template>
    <footer class="the-footer">
        <the-footer-main></the-footer-main>
        <footer-bottom></footer-bottom>
    </footer>
</template>

<style lang="scss">
    @import "~@zavtra/style/FooterMenuList.scss";

    .the-footer {
        position: relative;
        z-index: 1;
        .footer-bottom {
            background-color: #fff;
        }
    }
</style>
